/* eslint-disable max-params */
import { carConsumerService } from "../../../service/car-consumer-gateway-api";
import parseOrderList from "../../../utils/parsers/parse-order-list";
import { LeadServiceJava } from "../../../service/lead-service-java-api";
import { B2cGatewayService } from "../../../service/b2c-gateway-service";
import { VasBffService } from "../../../service/vas-bff-service";

/* eslint-disable no-unused-vars */
const getOrderList = (details, serviceType, isDesktop = false, parentCategory) => dispatch => {
    return new Promise((resolve, reject) => {
        carConsumerService.getOrderList(details).then((response) => {
            resolve(parseOrderList(response.data, serviceType, isDesktop, parentCategory));
        }).catch(() => {
            reject();
        });
    });
};

const getOrderListV2 = (details, serviceType, isDesktop = false, parentCategory) => dispatch => {
    return new Promise((resolve, reject) => {
        VasBffService.getOrderListV2(details).then((response) => {
            resolve(parseOrderList(response?.data?.data, serviceType, isDesktop, parentCategory));
        }).catch(() => {
            reject();
        });
    });
};

const getAppointmentByOrder = (payload) => () => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.getAppointmentByOrder(payload).then((response) => {
            resolve(response.data.detail);
        }).catch(() => {
            reject();
        });
    });
};

const getVasDetails = (token, orderId) => () => {
    return new Promise((resolve, reject) => {
        B2cGatewayService.getVasDetails(token, orderId)
            .then((response) => {
                resolve(response.data);
            });
    });
};

const getLeadTokenFromOrderNumber = ({orderNumber, orderItemId, authToken, isNewOrder = false}) => () => {
    return new Promise((resolve, reject) => {
        VasBffService.getLeadTokenFromOrderNumber({orderNumber, orderItemId, authToken, isNewOrder}).then(response => resolve(response.data))
            .catch(error => reject(error));
    });
};

export {
    getOrderList,
    getAppointmentByOrder,
    getVasDetails,
    getOrderListV2,
    getLeadTokenFromOrderNumber
};
